import { BreadCrumbs } from "../../../../../components/BreadCrumbs";
import { HomeSectionLayout } from "../../../../../components/HomeSectionLayout";
import { SECTION_COLORS } from "../../../../../utils/colors";
import { FeaturedContentItem } from "../index";

interface AttachmentItem extends FeaturedContentItem {
  title?: string;
  description?: string;
  public_url: string;
  thumbnail_url?: string;
  content_type?: string;
}

export default function AttachmentSection({ item, index }: { item: FeaturedContentItem; index: number }) {
  const attachment = item as AttachmentItem;
  const colors = SECTION_COLORS[index % SECTION_COLORS.length];

  return (
    <HomeSectionLayout.Container style={{
      backgroundColor: colors.bg,
      color: colors.text
    }}>
      <div style={{
        width: '100%'
      }}>
        <HomeSectionLayout.HeaderDescription>
          <BreadCrumbs.Container>
            <BreadCrumbs.LinkItem href="/attachments">
              Attachments
            </BreadCrumbs.LinkItem>
          </BreadCrumbs.Container>
        </HomeSectionLayout.HeaderDescription>
        <HomeSectionLayout.Header>{attachment.title}</HomeSectionLayout.Header>
      </div>
      <HomeSectionLayout.Content>
        <div style={{
          display: 'flex',
          flexDirection: 'row',
          gap: '20px',
          width: '100%'
        }}>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '5px'
          }}>
            <img
              src={attachment.public_url}
              style={{
                minWidth: '350px'
              }}
            />
          </div>
          {attachment.description && (
            <div style={{
              flex: 1
            }}>
              <p style={{
                fontSize: '1.1rem',
                lineHeight: '1.8',
                textAlign: 'justify',
              }}>
                {attachment.description}
              </p>
            </div>
          )}
        </div>
      </HomeSectionLayout.Content>
    </HomeSectionLayout.Container>
  )
}
